// extracted by mini-css-extract-plugin
module.exports = {"container":"CardWithTitle_container__AJJpH","contentSegment":"CardWithTitle_contentSegment__2r1CS","headerSegment":"CardWithTitle_headerSegment__1a3Fc"};